import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from './shared/constants/routes';
import { AuthenticationService } from './shared/services/authentication.service';
import { CurrentUserService } from './shared/services/current-user.service';
import { ConfigService } from './shared/services/config.service';

@Component({
  selector: 'check-auth',
  template: 'Redirection en cours vers packgemini...',
})
/**
 * Composant de callback FID — traite le retour OAuth2 après authentification.
 * Appelle /auth/me pour récupérer le profil complet depuis la BDD
 * (rôle résolu par le backend, pas depuis le token FID).
 */
export class CheckUserRolesComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private currentUserService: CurrentUserService,
    private configService: ConfigService,
    private router: Router
  ) {}

  ngOnInit(): void {

    if (this.configService.isAuthEnabled()) {
      // ── Mode FID (PROD) ──────────────────────────────────────────────
      this.authenticationService.isDoneLoading$.subscribe({
        next: () => {

          if (this.authenticationService.hasValidIdToken()) {
            //            l'intercepteur ajoute automatiquement Bearer getIdToken()
            this.authenticationService.checkUserAuthorization();

          } else {
            // id_token expiré → tenter un silent refresh
            this.authenticationService.refreshToken()
              .then(() => {
                this.authenticationService.checkUserAuthorization();
              })
              .catch(error => {
                console.error('[CHECK-AUTH] Refresh token échoué :', error);
                this.authenticationService.logIn();
              });
          }
        },
        error: (err) => {
          console.error('[CHECK-AUTH] Erreur isDoneLoading$ :', err);
          this.authenticationService.logIn();
        }
      });

    } else {
      // ── Mode INTERNAL (REC/INT/DEV) ─────────────────────────────────
      // Pas de FID → rediriger vers la page de login interne
      // (ou directement vers l'app si déjà loggé via loginWithPassword)
      if (this.currentUserService.getCurrentUser()) {
        this.router.navigateByUrl(`/${ROUTES.CORE_PATH}`);
      } else {
        this.router.navigateByUrl(`/${ROUTES.CHECK_AUTH_PATH ?? 'login'}`);
      }
    }
  }
}